export default __webpack_public_path__ + "static/media/py.fc6802df.png";